// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

// Util
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Third Party libraries
import * as $ from "jquery"

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"

// Services
import ClubService from "@/app/services/main/club/club-service.js"

export default {
	name: "ModalSocialReportContent",
	mixins: [toastMessageMixins],
	props: {
		reportContent: {
			required: true,
		},
		activeClub: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			reportText: "",
			isAPILoading: false,
		}
	},
	computed: {
		validationRules() {
			let field = {
				reportText: {},
			}

			field = vuelidateUtil.setRequiredValidation(field, "reportText")

			return field
		},
		getActiveGroup() {
			return this.$store.getters.getActiveGroup
		},
	},
	beforeDestroy() {
		this.closeModal()
	},
	methods: {
		openModal() {
			this.reportText = ""
			this.$v.$reset()
			$(this.$refs.reportContentModal).modal("show")
		},
		closeModal() {
			$(this.$refs.reportContentModal).modal("hide")
		},
		submitReport() {
			if (this.$v.$invalid) {
				return
			}

			this.isAPILoading = true

			const body = {
				reportedUserId: this.reportContent.userId,
				contentId: this.reportContent.id,
				groupId: this.getActiveGroup.id,
				contentType: this.reportContent.type, // 'POST' or 'COMMENT' ONLY
				reason: this.reportText,
			}

			ClubService.report(body).then((res) => {
				const { SUCCESS_CONTENT_REPORTED, ERROR_REPORT_CONTENT } = this.toastMessages.report()
				if (res.status === STATUS_CODES.SUCCESS) {
					// show toast message
					this.showCustomSuccessToast(SUCCESS_CONTENT_REPORTED)
					this.closeModal()
				} else {
					this.showAPIErrorToast(ERROR_REPORT_CONTENT, res)
				}
				this.isAPILoading = false
			})
		},
	},
	validations() {
		return this.validationRules
	},
}
